export default __webpack_public_path__ + "static/media/drone5.8d0908b6.jpg";